module.exports = __webpack_public_path__ + "static/media/image-3.b9f0fd63.jpeg";